import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PreorderBanner } from "./PreorderBanner";

export const Layout = () => {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 300);
    return () => clearTimeout(t);
  }, [pathname, hash, key]);
  return (
    <div className="flex min-h-screen flex-col">
      <PreorderBanner />
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
};

export const PageHero = ({ eyebrow, title, script, children, testid }) => (
  <section className="relative overflow-hidden bg-[#FFF4F8]" data-testid={testid}>
    <div className="mx-auto max-w-7xl px-6 pb-14 pt-16 sm:pt-20">
      <p className="eyebrow rise">{eyebrow}</p>
      <h1 className="rise mt-3 font-display text-4xl font-bold leading-[1.05] sm:text-5xl lg:text-6xl" style={{ animationDelay: ".08s" }}>
        {title} {script && <span className="font-script font-normal text-[#FF1F8E]">{script}</span>}
      </h1>
      {children && <div className="rise mt-5 max-w-2xl text-base text-[#0E0B0D]/70 sm:text-lg" style={{ animationDelay: ".16s" }}>{children}</div>}
    </div>
    <div className="stitch-line" />
  </section>
);
